import React from 'react'
import Header from '../../pages-components/B2B/Login/Header'

const Login = () => {
  return (
    <div>
                  <Header/>

    </div>
  )
}

export default Login
